import React, { useEffect, useState } from 'react';
import { Container, Jumbotron, Table } from 'react-bootstrap';
import axios from 'axios';
export const StudentView = () => {
  const [student_data, set_student_data] = useState([]);
  const _get_student_data = () => {
    axios({
      method: 'GET',
      url: '/.netlify/functions/fetchStudents',
    })
      .then((response) => {
        set_student_data(response.data);
      })
      .catch(console.error);
  };
  useEffect(_get_student_data, []);
  return (
    <div>
      <Container className='p-2' fluid>
        <Jumbotron>
          <h1>Student Record</h1>
        </Jumbotron>
        <Jumbotron>
          <Table
            className='table-cutom-class'
            striped
            bordered
            hover
            responsive
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Email</th>
                <th>Course</th>
              </tr>
            </thead>
            <tbody>
              {student_data.length > 0
                ? student_data.map((elem, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{elem.student_name}</td>
                        <td>{elem.student_email}</td>
                        <td>{elem.course_name}</td>
                      </tr>
                    );
                  })
                : ''}
            </tbody>
          </Table>
          <h3>Total = {student_data.length > 0 ? student_data.length : ''}</h3>
        </Jumbotron>
      </Container>
    </div>
  );
};
